import LTR from "@brand-icons/ploom/device-phone/device-phone-ltr.svg";

import { iconFactory } from "../iconFactory";

export const DevicePhoneIcon = iconFactory("DevicePhoneIcon", LTR);
